import { usePopover } from '@calendly/ui/components/popover';
import classNames from 'classnames';
import { forwardRef, useCallback, useRef } from 'react';
import { Dialog, OverlayArrow, Popover as AriaPopover } from 'react-aria-components';
import { isFilterMenuPanelCheckboxFocused, isFilterMenuProtectedTarget, isFilterMenuTriggerClosePending, prepareFilterMenuTriggerClose, shouldSuppressFilterMenuClose } from './filter_menu_portal_dismiss_guard';
const dialogStyles = "dstc1mr";
const overlayArrowIconCss = "o9qgnbm";
const overlayArrow = "okzug1i";

/**
 * CUI PopoverContent closes on any interact-outside target except the trigger node itself.
 * Filter panels need field controls, portaled submenus, and panel body content to count as "inside".
 */
export const FilterMenuProtectedPopoverContent = forwardRef(({
  children,
  placement,
  className,
  showArrow,
  offset = 8,
  ...rest
}, ref) => {
  const {
    triggerRef,
    onClose
  } = usePopover();
  const suppressCloseRef = useRef(false);
  const handleOutsideInteraction = useCallback(element => {
    if (element === triggerRef?.current) {
      const needsPopoverDismissBackup = isFilterMenuPanelCheckboxFocused() || shouldSuppressFilterMenuClose();
      prepareFilterMenuTriggerClose();
      suppressCloseRef.current = false;
      return needsPopoverDismissBackup;
    }
    if (isFilterMenuProtectedTarget(element)) {
      suppressCloseRef.current = true;
      return false;
    }
    suppressCloseRef.current = false;
    return true;
  }, [triggerRef]);
  const handleOpenChange = useCallback(open => {
    if (!open) {
      if (!isFilterMenuTriggerClosePending() && (suppressCloseRef.current || shouldSuppressFilterMenuClose())) {
        suppressCloseRef.current = false;
        return;
      }
      onClose?.();
    }
  }, [onClose]);
  return <AriaPopover {...rest} ref={ref} className={classNames(overlayArrow, className)} placement={placement} onOpenChange={handleOpenChange} triggerRef={triggerRef} shouldCloseOnInteractOutside={handleOutsideInteraction} isKeyboardDismissDisabled offset={offset}>
      {showArrow && <OverlayArrow>
          <svg className={overlayArrowIconCss} width="12" height="12" viewBox="0 0 12 12">
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>}
      <Dialog role="dialog" className={dialogStyles}>
        {children}
      </Dialog>
    </AriaPopover>;
});

require("./filter_menu_popover_content.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_menu_popover_content.js");